/**
 * Temporary mock payloads for widgets that still lack a real data source.
 * Merged onto the widget skeleton from totem-home.config.ts at runtime.
 */

export const TOTEM_HOME_WIDGET_MOCKS: { [widgetId: string]: any } = {
    'tour-travel-documents': {
        buttonList: [{
            icon: 'fa-plane',
            text: 'tour-travel-documents.params.imageList.0.text',
            link: 'https://api.dev.entourance.com/uploads/documents/1743072245-pdf-test.pdf',
        }, {
            icon: 'fa-bed',
            text: 'tour-travel-documents.params.imageList.1.text',
            link: 'https://api.dev.entourance.com/uploads/documents/1743072245-pdf-test.pdf',
        }, {
            icon: 'fa-car',
            text: 'tour-travel-documents.params.imageList.2.text',
            link: 'https://api.dev.entourance.com/uploads/documents/1743072245-pdf-test.pdf',
        }, {
            icon: 'fa-file-certificate',
            text: 'tour-travel-documents.params.imageList.3.text',
            link: 'https://api.dev.entourance.com/uploads/documents/1743072245-pdf-test.pdf',
        }],
    },
    'useful-contacts': {
        actionList: [{
            icon: 'fa-phone',
            text: 'useful-contacts.params.actionList.0.text',
            link: 'https://api.dev.entourance.com/uploads/documents/1743072245-pdf-test.pdf',
        }, {
            icon: 'fa-shield',
            text: 'useful-contacts.params.actionList.1.text',
            link: 'https://api.dev.entourance.com/uploads/documents/1743072245-pdf-test.pdf',
        }, {
            icon: 'fa-landmark',
            color: 'outline-primary',
            text: 'useful-contacts.params.actionList.2.text',
            link: 'https://api.dev.entourance.com/uploads/documents/1743072245-pdf-test.pdf',
        }],
    },
    'after-survey-current': {
        actionList: [{
            text: 'after-survey-current.params.actionList.0.text',
            link: 'https://docs.google.com/forms',
        }],
    },
    'after-survey-next': {
        productsData: [{
            id: 'custom_destination_0',
            type: 'custom',
            resource: 'custom',
            title: 'after-survey-next.imageList.0.text',
            description: 'after-survey-next.imageList.0.description',
            images: ['https://api.dev.entourance.com/uploads/images/1768561401-media.webp'],
        }, {
            id: 'custom_destination_1',
            type: 'custom',
            resource: 'custom',
            title: 'after-survey-next.imageList.1.text',
            description: 'after-survey-next.imageList.1.description',
            images: ['https://api.dev.entourance.com/uploads/images/1768561400-consigli-di-viaggio-per-il-vietnam.jpg'],
        }],
    },
    'after-traveller-profile': {
        title: 'after-traveller-profile.title',
        description: 'after-traveller-profile.abstract',
        actionList: [{
            text: 'after-traveller-profile.params.actionList.0.text',
        }],
    },
};

export const TOTEM_HOME_WIDGET_MOCK_TRANSLATIONS: {
    [language: string]: { [id: string]: string }
} = {
    it_IT: {
        'tour-travel-documents.params.imageList.0.text': 'Volo',
        'tour-travel-documents.params.imageList.1.text': 'Hotel',
        'tour-travel-documents.params.imageList.2.text': 'Auto',
        'tour-travel-documents.params.imageList.3.text': 'Contratto',

        'useful-contacts.params.actionList.0.text': 'Emergenza',
        'useful-contacts.params.actionList.1.text': 'Polizia',
        'useful-contacts.params.actionList.2.text': 'Ambasciata',

        'after-survey-current.params.actionList.0.text': 'Compila il questionario',

        'after-traveller-profile.title': 'Esploratore Organizzato',
        'after-traveller-profile.abstract': 'Mostra pianificazione, rispetta le scadenze, completa le sfide pratiche. Affidabile, meticoloso, orientato alla sicurezza.',
        'after-traveller-profile.params.actionList.0.text': 'Condividi',

        'after-survey-next.imageList.0.text': 'INDONESIA',
        'after-survey-next.imageList.0.description': 'Perfetto per gli amanti della natura',
        'after-survey-next.imageList.1.text': 'VIETNAM',
        'after-survey-next.imageList.1.description': 'Perfetto per gli amanti della natura',
    },
    en_EN: {
        'tour-travel-documents.params.imageList.0.text': 'Flight',
        'tour-travel-documents.params.imageList.1.text': 'Hotel',
        'tour-travel-documents.params.imageList.2.text': 'Car',
        'tour-travel-documents.params.imageList.3.text': 'Contract',

        'useful-contacts.params.actionList.0.text': 'Emergency',
        'useful-contacts.params.actionList.1.text': 'Police',
        'useful-contacts.params.actionList.2.text': 'Embassy',

        'after-survey-current.params.actionList.0.text': 'Fill out the survey',

        'after-traveller-profile.title': 'Organized Explorer',
        'after-traveller-profile.abstract': 'Exhibits planning, meets deadlines, completes practical challenges. Reliable, meticulous, safety-oriented.',
        'after-traveller-profile.params.actionList.0.text': 'Share',

        'after-survey-next.imageList.0.text': 'INDONESIA',
        'after-survey-next.imageList.0.description': 'Perfect for nature lovers',
        'after-survey-next.imageList.1.text': 'VIETNAM',
        'after-survey-next.imageList.1.description': 'Perfect for nature lovers',
    },
};
